import { render, staticRenderFns } from "./FortnoxVoucherPreview.vue?vue&type=template&id=af121c54&"
import script from "./FortnoxVoucherPreview.vue?vue&type=script&lang=js&"
export * from "./FortnoxVoucherPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports